import React, { useEffect, useState } from "react";
import aboutBg from "../../assets/images/aboutBg.jpeg";

import aboutIcon1 from "../../assets/images/aboutIcon1.png";
import aboutIcon2 from "../../assets/images/aboutIcon2.png";
import aboutIcon3 from "../../assets/images/aboutIcon3.png";

import empower from "../../assets/images/empower.png";

import worksteps from "../../assets/images/worksteps.png";

import about1 from "../../assets/images/about1.png";

import about2 from "../../assets/images/about2.png";

import about3 from "../../assets/images/about3.png";
import { ContentImageComponent } from "./contentimagecompoenent";

import "./style.css";
import {
  fontSize_detail25,
  fontSize_headerTitles,
  fontSize_headerTitles35,
  fontSize_headings,
  fontSize_lendings,
  maxWidth,
} from "../../shared/styleconfig";
import MaskLoader from "../../components/MaskLoader";
import { HowItWorks } from "./howitworkscomponent";
import { WebsiteName } from "../../App";

const About = () => {
  const [loader, setLoader] = useState(true);

  React.useEffect(() => {
    document.title = WebsiteName + " - About";
    setTimeout(() => {
      setLoader(false);
    }, 5000);
  }, []);

  return loader ? (
    <MaskLoader />
  ) : (
    <div className="w-full about-us font-[Helvetica LT Std]">
      <div
        style={{
          backgroundImage: `url(${aboutBg})`,
        }}
        className={`lg:min-h-[625px] md:min-h-[425px] xs:min-h-[325px] xs:bg-cover w-full relative bg-center bg-shadow`}>
        <div
          className={`bg-[#0061fc] rounded-t-[30px] mix-blend-multiply absolute bottom-0 w-[80%]  ${maxWidth} lg:min-h-[300px] md:min-h-[265px] sm:min-h-[215px] xs:min-h-[200px] left-[50%] translate-x-[-50%]`}></div>
        <div
          className={`w-[80%] ${maxWidth} lg:min-h-[300px] md:min-h-[265px] sm:min-h-[215px] xs:min-h-[200px] absolute bottom-0 left-[50%] translate-x-[-50%]`}>
          <p
            className={`uppercase leading-[35px] font-semibold opacity-1 text-[#76ABFF] absolute top-[20%] lg:left-[60px] xs:left-[10%] ${fontSize_headerTitles} `}>
            About Us
          </p>
          <p
            className={` ${fontSize_headings} ${fontSize_lendings} font-semibold opacity-1 text-[#FFFFFF] max-w-[895px] mt-[36px] absolute top-[25%] lg:left-[60px] tracking-wide xs:left-[10%]`}>
            Driven by a Common
            <br />
            Passion. Winning.
          </p>
        </div>
      </div>

      <div>
        <div
          className={`w-[80%] ${maxWidth} bg-[#0061FC] rounded-b-[30px] mx-auto font-[Helvetica Neue LT Std] flex lg:p-[60px] justify-center items-center xs:p-[20px] lg:flex-row xs:flex-col lg:gap-[0px] xs:gap-[20px]`}>
          <div
            className={` h-auto flex items-center flex-col text-center mx-auto`}>
            <img
              src={aboutIcon1}
              className={`md:w-[48px] sm:w-[20px] xs:w-[20px]`}
            />
            <p
              className={`break-words lg:leading-[70px] md:leading-[40px] sm:leading-[30px] ${fontSize_headerTitles35} xs:leading-[20px] text-[#76ABFF] font-bold`}>
              User-friendly
            </p>
            <div
              className={`break-words  lg:leading-[30px] md:leading-[18px] sm:leading-[20px] ${fontSize_detail25} xs:leading-[15px] text-white font-normal`}>
              Create algos using
              <br />
              drag-and-drop coding or rent
              <br />
              an algo from the community.
            </div>
          </div>

          <div
            className={` h-auto flex items-center flex-col text-center mx-auto`}>
            <img
              src={aboutIcon2}
              className={`md:w-[66px] sm:w-[35px] xs:w-[35px]`}
            />
            <p
              className={`break-words  lg:leading-[70px] md:leading-[40px] sm:leading-[30px] ${fontSize_headerTitles35} xs:leading-[20px] text-[#76ABFF] font-bold`}>
              Leverage Expertise
            </p>
            <div
              className={`break-words lg:leading-[30px] md:leading-[18px] sm:leading-[20px] ${fontSize_detail25} xs:leading-[15px] text-white font-normal`}>
              Use profitable algos
              <br />
              created by others in the
              <br />
              community.
            </div>
          </div>

          <div
            className={` h-auto flex items-center flex-col text-center mx-auto`}>
            <img
              src={aboutIcon3}
              className={`md:w-[66px] sm:w-[35px] xs:w-[35px]`}
            />
            <p
              className={`break-words  lg:leading-[70px] md:leading-[40px] sm:leading-[30px] ${fontSize_headerTitles35} xs:leading-[20px] text-[#76ABFF] font-bold`}>
              Automatic
            </p>
            <div
              className={`break-words lg:leading-[30px] md:leading-[18px] sm:leading-[20px] ${fontSize_detail25} xs:leading-[15px] text-white font-normal`}>
              Automate your trades
              <br />
              with an algo and don’t
              <br />
              worry anymore.
            </div>
          </div>
        </div>
      </div>

      <ContentImageComponent
        subTitle={`WHO WE ARE`}
        mainTitle={[
          `Empowering Investors,`,
          `from Professional`,
          `Traders to Newcomers`,
        ]}
        desc={`TRADEFOLIO aims to empower all kinds of investors by simplifying the complex world of algorithmic trading. By using a user-friendly platform and a unique drag-and-drop Algo Builder, we have made creating trading algorithms an easy task for all. You can easily create your own algorithm in minutes. Our Algo Marketplace allows users to monetize their knowledge or benefit from the experience of other traders. We believe in inclusivity and accessible trading for all. Join us on this journey towards starting a new era of investing.`}
        contentImage={empower}
        hasButton={false}
        imageIsOnRight={true}
        removeMaxWidth={true}
      />

      <div
        className={`flex flex-col lg:mb-[50px] md:mb-[50px] sm:mb-[50] xs:mb-[30px]`}>
        {/* <img src={worksteps} className={`w-[80%] mx-auto ${maxWidth} `} /> */}
        <HowItWorks />
      </div>

      <ContentImageComponent
        subTitle={`BACKED BY COMMUNITY`}
        mainTitle={[
          `Algorithms built by`,
          `the Community, for the`,
          `Community.`,
        ]}
        desc={`Create and refine your own trading algorithm or subscribe to an algorithm created by the trading community.`}
        contentImage={about1}
        hasButton={false}
        imageIsOnRight={false}
        removeMaxWidth={true}
      />

      <ContentImageComponent
        subTitle={`START NOW`}
        mainTitle={[`More Than just an`, `Algorithmic Trading`, `Platform`]}
        desc={`Algorithmic trading (also called automated trading, black-box trading, or algo-trading) uses a computer program that follows a defined set of instructions (an algorithm) to place a trade. The trade, in theory, can generate profits at a speed and frequency that is impossible for a human trader.`}
        contentImage={about2}
        hasButton={false}
        imageIsOnRight={true}
        removeMaxWidth={true}
      />

      <ContentImageComponent
        subTitle={""}
        mainTitle={[
          `Don’t want to create`,
          `your own algo, get one`,
          `from the community.`,
        ]}
        desc={`Investing doesn’t have to be confusing and you shouldn’t have to worry about creating your own algorithm. You can simply use a pre-made algo made by a seasoned trader from the community.`}
        contentImage={about3}
        hasButton={true}
        imageIsOnRight={false}
        hasPadding={false}
        isLastSection={true}
        removeMaxWidth={true}
      />
    </div>
  );
};

export default About;
